import React from 'react';
import DivisorItem from "./divisor-item.jsx";
import {FaAddressCard, FaEnvelope, FaPhone} from "react-icons/fa";
import projectUtils from "../../../../../../../utils/project-utils.js";

const CompanyDetails = ({data}) => {
    return (
        <>
            <p className={`text-[16px] text-white font-bold  p-2 bg-[#8eacea] mb-0`}>
                {data.name || "Empresa"}
            </p>
            <div className={"p-2"}>
                <DivisorItem icon={<FaAddressCard size={18}/>} text={"CNPJ"} value={projectUtils.formatCnpjToView(data.value)}/>
                <DivisorItem icon={<FaEnvelope size={18}/>} text={"E-mail"} value={projectUtils.formatCnpjToView(data.email)}/>
                <DivisorItem icon={<FaPhone size={18}/>} text={"Telefone"} value={projectUtils.formatCnpjToView(data.phone)}/>
            </div>
        </>
    )
};

export default CompanyDetails;